import { createAction, props } from "@ngrx/store";

export const setPrimaryColor = createAction('[Theme] Set Primary Color', props<{ color: string }>());
export const setFont = createAction('[Theme] Set Font', props<{ font: string }>());
export const setDarkMode = createAction('[Theme] Set Dark Mode', props<{ darkMode: boolean }>());
export const loadTheme = createAction('[Theme] Load Theme Options');